import "./style"

export default function HeaderCard(props) {
  const {className, ...restProps} = props

  return (
    <div className={classNames("merfoto-components-header-card", className)} {...restProps} />
  )
}
